import type {Route} from "@tanstack/react-router";
import {GenericLoadingComponent} from "~/components/genericLoadingComponent";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function EmbeddedPendingComponent({route}: {route: Route}) {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", route.id, "pendingComponent");
    }

    return <GenericLoadingComponent />;
}
